/**
 * @module components/get-help
 * @description Barrel export for GetHelp component
 */

export { GetHelp } from './get-help';
